import { combineReducers } from 'redux';

const single = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_FULFILLED':
      return action.payload.data;
    default:
      return state;
  }
};

const data = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDORS_FULFILLED':
      return action.payload.data;
    case 'FETCH_VENDORS_REJECTED':
      return [];
    default:
      return state;
  }
};

const editing = (state = null, action) => {
  switch (action.type) {
    case 'SET_VENDOR':
      return action.payload;
    default:
      return state;
  }
};

const management = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDORS_MANAGEMENT_FULFILLED':
      return action.payload.data;
    case 'FETCH_VENDORS_MANAGEMENT_REJECTED':
      return [];
    default:
      return state;
  }
};

const vendorsToMerge = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDORS_TO_BE_MERGED_FULFILLED':
      return action.payload.data;
    case 'FETCH_VENDORS_TO_BE_MERGED_REJECTED':
      return [];
    default:
      return state;
  }
};

const filters = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_MANAGEMENT_FILTERS_FULFILLED':
      return action.payload.data.result;
    default:
      return state;
  }
};

const filtersLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_MANAGEMENT_FILTERS_FULFILLED':
      return true;
    case 'FETCH_MANAGEMENT_FILTERS_PENDING':
      return false;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_PENDING':
    case 'FETCH_VENDORS_PENDING':
      return true;
    case 'FETCH_VENDOR_REJECTED':
    case 'FETCH_VENDOR_FULFILLED':
    case 'FETCH_VENDORS_REJECTED':
    case 'FETCH_VENDORS_FULFILLED':
      return false;
    default:
      return state;
  }
};

const errorMessage = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_PENDING':
    case 'FETCH_VENDOR_FULFILLED':
      return null;
    case 'FETCH_VENDOR_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const isFetchingManagement = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDORS_MANAGEMENT_PENDING':
      return true;
    case 'FETCH_VENDORS_MANAGEMENT_REJECTED':
    case 'FETCH_VENDORS_MANAGEMENT_FULFILLED':
      return false;
    default:
      return state;
  }
};

const managementLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_VENDORS_MANAGEMENT_PENDING':
      return false;
    case 'FETCH_VENDORS_MANAGEMENT_REJECTED':
    case 'FETCH_VENDORS_MANAGEMENT_FULFILLED':
      return true;
    default:
      return state;
  }
};

const errorMessageManagement = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_VENDORS_MANAGEMENT_PENDING':
    case 'FETCH_VENDORS_MANAGEMENT_FULFILLED':
      return null;
    case 'FETCH_VENDORS_MANAGEMENT_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const vendors = combineReducers({
  single,
  data,
  editing,
  management,
  isFetching,
  errorMessage,
  isFetchingManagement,
  errorMessageManagement,
  managementLoaded,
  filters,
  filtersLoaded,
  vendorsToMerge,
});

export default vendors;
